import React from "react";
import BaseInnerTitle from "../../sisu/title/BaseInnerTitle.sisu";

const NeoInnerTitle = (props) => {
  return (<BaseInnerTitle custom="p-col p-col-12 titulo-interno-card" {...props}>
    {props.children}
    </BaseInnerTitle>);
};

export default NeoInnerTitle;